import React, { useContext } from 'react';
import { PageStateContext } from '../../context/PageStateContext';

import HiddenForm from '../HiddenForm';
import { getDraftUrl, getPageUrlFromPageId } from '../../utilities/urlHelper';

const StaleDraftNotification = ({ pageId, draftId }) => {
    const pageUrl = getPageUrlFromPageId(pageId);
    const draftUrl = `${getDraftUrl(draftId)}?redirectUrl=${pageUrl}`;

    return (
        <div className="warning-message flex-none print-hide">
            <div className="message-text">
                There have been changes to
                {' '}
                <a target="_blank" href={pageUrl} rel="noreferrer">this page</a>
                {' '}
since you started this draft.
            </div>
            <HiddenForm style="message-btn red h5" value="Discard changes" method="delete" url={draftUrl} />
        </div>
    );
};

const DraftNotification = () => {
    const { pageState } = useContext(PageStateContext);
    const { draft } = pageState || {};

    if (draft && draft.is_outdated) {
        return <StaleDraftNotification pageId={draft.page_id} draftId={draft.id} />;
    }

    return null;
};

export default DraftNotification;
